import React from 'react'

import { useNavigation } from 'react-router-dom'

/** Below this a navigation feels instant; a bar would only flicker. */
const SHOW_AFTER_MS = 120

/**
 * The app-wide "next screen is coming" signal: a 2px bar at the top while
 * a route's code or loader is pending. Lists and CTAs keep their own
 * in-place pending states; this covers the gap between a tap and the next
 * screen, where nothing else on screen changes.
 */
export function NavigationProgress() {
    const navigation = useNavigation()
    const pending = navigation.state !== 'idle'
    const [visible, setVisible] = React.useState(false)

    React.useEffect(() => {
        if (!pending) {
            setVisible(false)
            return
        }
        const timer = window.setTimeout(() => setVisible(true), SHOW_AFTER_MS)
        return () => window.clearTimeout(timer)
    }, [pending])

    if (!visible) return null
    return <div className="nav-progress" aria-hidden="true" />
}
